import {
  useState,
  useContext,
  createContext,
  useCallback,
  useEffect,
} from 'react'
import { useSelector } from 'react-redux'
import { getUserInfo, updateUserChecklistStatus } from '../Api/user'
import { getStartedChecklistData } from '../Utils/data'
import { Platform } from './PlatformContext'

export const GetStartedContext = createContext({
  currentStep: -1,
})

const GetStartedContextProvider = ({ children }) => {
  const platform = useContext(Platform)
  const [steps, setSteps] = useState(getStartedChecklistData(platform))
  const user = useSelector((state) => state?.user.data)
  const [currentStepIdFromApi, setCurrentStepIdFromApi] = useState(null)
  const [currentStep, setCurrentStep] = useState(-1)
  const [getStarted, setGetStarted] = useState(true)
  const [tagPopup, setTagPopup] = useState(false)

  const fetchUserCurrentStep = useCallback(async () => {
    const apiResponse = await getUserInfo()
    // console.log(apiResponse)
    if (apiResponse?.onboardingcheckid) {
      const temp = Number(apiResponse.onboardingcheckid)
      // setCurrentStep(temp)
    }
  }, [])

  const updateStatus = (stepId, status) => {
    setSteps((prevSteps) =>
      prevSteps.map((step) => {
        if (step.id === Math.floor(stepId)) {
          return { ...step, status }
        }
        return step
      })
    )
  }
  useEffect(() => {
    fetchUserCurrentStep()
    if (currentStep > 1) {
      setSteps((prevSteps) =>
        prevSteps.map((step) => {
          if (step.id < currentStep) {
            return { ...step, status: 'COMPLETE' }
          }
          return step
        })
      )
      updateStatus(currentStep, 'ACTIVE')
    }
  }, [user, fetchUserCurrentStep])

  const moveToNextStep = (stepId) => {
    // console.log('stepId', stepId)
    if (stepId <= steps.length - 1) {
      // handling for 2.5 case
      // if (stepId > 0) updateStatus(stepId - 1, 'COMPLETE')

      // If the current step is not the last step, mark the current step as done
      updateStatus(stepId, 'COMPLETE')
      updateStatus(stepId + 1, 'ACTIVE')
      setCurrentStep(stepId + 1)
      updateUserChecklistStatus(stepId + 1)
    } else {
      // If the current step is the last step, mark it as done
      updateUserChecklistStatus(stepId + 1)
    }
  }

  const getStartedContextValue = {
    currentStep: currentStep,
    steps,
    setSteps,
    moveToNextStep,
    setCurrentStep,
    currentStepIdFromApi,
    getStarted,
    setGetStarted,
    tagPopup,
    setTagPopup,
  }

  return (
    <GetStartedContext.Provider value={getStartedContextValue}>
      {children}
    </GetStartedContext.Provider>
  )
}

export default GetStartedContextProvider
